import { createContext } from "react";
const ParentSheetContext = createContext({
  zIndex: 1e5
});
const SheetInsideSheetContext = createContext(null);
export {
  ParentSheetContext,
  SheetInsideSheetContext
};
//# sourceMappingURL=contexts.js.map
